/**
 * Compact product label for lists, switchers, roster checkboxes, filters:
 * trimmed Jira project key when set; otherwise trimmed display name.
 * Avoids duplicated "KEY · Name" or "Name (KEY)" when both describe the same thing.
 */
export function productCompactDisplayLabel(product: {
  name?: string | null;
  jira_project_key?: string | null;
}): string {
  const key = typeof product.jira_project_key === 'string' ? product.jira_project_key.trim() : '';
  if (key.length > 0) return key;
  const name = typeof product.name === 'string' ? product.name.trim() : '';
  return name;
}
